import React from "react";

/**
 * The small bordered "i" that toggles a note strip.
 *
 * These replace the long standing hint paragraphs the old Overview and By
 * Service pages carried above their tables: the caveats still need saying —
 * a forecast that a single spike can distort, a most-recent day that always
 * reads low, resource names that depend on a cost-allocation tag — but they
 * do not need to occupy the page every time someone opens it.
 *
 * Only one note is open at a time; the parent owns that state, so opening one
 * closes any other without the notes having to know about each other.
 */
export default function InfoSquare({ id, openNote, onToggle, label }) {
  const open = openNote === id;
  return (
    <button
      type="button"
      className="info-square"
      aria-expanded={open}
      aria-controls={`note-${id}`}
      aria-label={label}
      title={label}
      onClick={() => onToggle(open ? null : id)}
    >
      i
    </button>
  );
}

export function NoteStrip({ id, openNote, children }) {
  if (openNote !== id) return null;
  return (
    <div className="note-strip" id={`note-${id}`}>
      {children}
    </div>
  );
}
